import { StandardEvents } from '@shopify/events';
class BrandCarousel extends HTMLElement {
  connectedCallback() {
    this.abort?.abort(); this.abort = new AbortController();
    const { signal } = this.abort;
    const track = this.querySelector('.wb-brand__track');
    const buttons = [...this.querySelectorAll('[data-direction]')];
    const update = () => {
      const slides = [...track.children];
      const left = track.getBoundingClientRect().left;
      let current = 0;
      slides.forEach((slide, i) => { if (Math.abs(slide.getBoundingClientRect().left - left) < Math.abs(slides[current].getBoundingClientRect().left - left)) current = i; });
      this.current = current;
      buttons.forEach(button => { button.hidden = false; button.disabled = Number(button.dataset.direction) < 0 ? current === 0 : current === slides.length - 1; });
    };
    const move = direction => {
      const slide = track.children[Math.max(0, Math.min(track.children.length - 1, (this.current || 0) + direction))];
      track.scrollBy({ left: slide.getBoundingClientRect().left - track.getBoundingClientRect().left, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    };
    buttons.forEach(button => button.addEventListener('click', () => move(Number(button.dataset.direction)), { signal }));
    track.addEventListener('scroll', update, { signal, passive: true });
    track.addEventListener('keydown', event => { if (event.target === track && ['ArrowLeft','ArrowRight'].includes(event.key)) { event.preventDefault(); move(event.key === 'ArrowRight' ? 1 : -1); } }, { signal });
    this.resize = new ResizeObserver(update); this.resize.observe(track); update();
  }
  disconnectedCallback() { this.abort?.abort(); this.resize?.disconnect(); }
}
class ProductSpecifications extends HTMLElement {
  connectedCallback() {
    this.abort?.abort(); this.abort = new AbortController(); this.revision = 0;
    document.addEventListener(StandardEvents.productSelect, this.update, { signal: this.abort.signal });
  }
  disconnectedCallback() { this.abort?.abort(); this.revision++; }
  update = async event => {
    const target = event.target;
    if (!(target instanceof Element) || target.closest('dialog, product-card, quick-add-component')) return;
    if (target.closest('variant-picker')?.dataset.productId !== this.dataset.productId) return;
    const revision = ++this.revision;
    try {
      const { detail } = await event.promise;
      if (!this.isConnected || revision !== this.revision || String(detail?.productId) !== this.dataset.productId) return;
      const incoming = detail.html?.querySelector(`wb-product-specifications[data-section-id="${CSS.escape(this.dataset.sectionId)}"]`);
      if (!incoming) return;
      const open = new Set([...this.querySelectorAll('details[open]')].map(el => el.dataset.group));
      const focus = this.contains(document.activeElement) ? document.activeElement.closest('details')?.dataset.group : null;
      this.replaceChildren(...[...incoming.childNodes].map(node => node.cloneNode(true)));
      this.hidden = incoming.hidden;
      this.querySelectorAll('details').forEach(el => { el.open = open.has(el.dataset.group); if (el.dataset.group === focus) el.querySelector('summary')?.focus({ preventScroll: true }); });
    } catch { /* A failed/aborted selection retains the last resolved information. */ }
  };
}
if (!customElements.get('wb-brand-carousel')) customElements.define('wb-brand-carousel', BrandCarousel);
if (!customElements.get('wb-product-specifications')) customElements.define('wb-product-specifications', ProductSpecifications);
